<ridango-block-full-width>
    <div class="payment-method-area" *ngIf="(allPaymentMethodsArray$|async)?.length === 0">
        <p class="title">{{'PAYMENT_METHOD' | translate}}</p>
        <p class="align-center" *ngIf="!(loading$|async)">
            {{'PAYMENT_METHODS_LOADING_FAIL' | translate}}</p>

        <div class="align-center loader-btn">
            <!-- TODO: Loading button component -->
            <button class="btn btn--big btn--primary" (click)="fetchMethods()"
                *ngIf="!(loading$|async)">{{'BTN_TRY_AGAIN' | translate}}</button>
            <button class="btn btn--big btn--primary" *ngIf="(loading$|async)" disabled>
                <span class="btn-loader">
                    <span>
                        <span class="btn-loader__img"><img src="assets/button_loader.png" alt=""></span>
                        <span class="btn-loader__text">{{'BUTTON_LOADER_TEXT' |
                            translate}}</span>
                    </span>
                </span>
            </button>
        </div>
    </div>




    <ridango-single-payment-method *ngIf="(allPaymentMethodsArray$|async)?.length === 1"
        [method]="(selectedPaymentMethod$|async)" [lang]="locale" [showTitle]="false"></ridango-single-payment-method>
    <ridango-multiple-payment-methods *ngIf="(allPaymentMethodsArray$|async)?.length > 1" #methodsEl
        [methods]="(allPaymentMethodsArray$|async)" [lang]="locale" [selectedMethod]="(selectedPaymentMethod$ | async)"
        (onMethodSelected)="methodSelected($event)" (onMovedLeft)="selectLeft($event)"
        (onMovedRight)="selectRight($event)" (onFocused)="focus($event)" (onBlurred)="blur($event)">
    </ridango-multiple-payment-methods>
</ridango-block-full-width>
